import axios from "axios";
import app from './main'
import store from './store/index'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

instance.interceptors.request.use(
    (config) => {
        if (store.state.token) {
            config.headers['Authorization'] = `B ${store.state.token}`
        }
        return config
    }
)

instance.interceptors.request.use(config => {
    app.$Progress.start();
    return config
}, (error) => {
    app.$Progress.fail();
    return Promise.reject(error);
})

instance.interceptors.response.use(response => {
    app.$Progress.finish()
    return response
}, (error) => {
    app.$Progress.fail();
    return Promise.reject(error);
})

export default instance;